export class User {
  name!: string;
  lastLogin!: string;
  flActive!: string;
  language?: number;
}

export class UserUpdate {
  flActive!: boolean;
  language?: number;
}
